import React, {Component} from 'react';
import styled from "styled-components";
import ReactSlider from 'react-slider'

const baseSize = 360;
const newPaneSize = 160;
const contentHeight = "85%";
const contentWidth = "65%";
const sidebarWidth = "14.5%";
const zoomWidth = "2.5%";
const marginWidth = "8.75%";
const sliderRight = "26%";
const borderRadius = "0.35rem";
const bucketRoot = "https://mikehallstudio.s3.amazonaws.com/fracto/orbitals"

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: ${contentWidth} ${zoomWidth} ${sidebarWidth}
    width: 82.5%;
    margin: 0 ${marginWidth} 0; 
`;

const Graphics = styled.div`
    width: ${contentWidth};
    height: ${contentHeight};
    overflow: scroll;
    position: absolute;
    border 2px solid lightgrey;    
    border-radius: ${borderRadius};
    box-shadow: 0.25rem 0.25rem 1.0rem rgba(0,0,0,0.15);
`;

const Sidebar = styled.div`
    position: absolute;
    right:${marginWidth};
    width: ${sidebarWidth};
    height: ${contentHeight};
    border-radius: ${borderRadius};
    border: 2px solid lightgrey;
    background-color: white;
`;

const StyledSlider = styled(ReactSlider)`
    position: absolute !important;
    right: ${sliderRight};
    height: ${contentHeight};
`;

const StyledThumb = styled.div`
    width: 1.5rem;
    height: 1.5rem;
    line-height: 1.5rem;
    text-align: center;
    margin: 0 0.35rem;
    background-color: #666666;
    border-radius: 0.25rem;
    color: #eeeeee;
    cursor: grab;
    padding: 0px 5px;
    text-shadow: 0.25rem 0.25rem 0.25rem rgba(0,0,0,0.25);
`;

const StyledTrack = styled.div`
    left: 1rem;
    right: 0;
    width: 0.75rem;
    background-color: ${props => props.index === 2 ? '#f00' : props.index === 1 ? '#ddd' : '#ccc'};
`;

const CellWrapper = styled.div`
    position: absolute;
    margin: 0;
`;

const WindowPaneWrapper = styled.div`
    margin: 0;
`;

const OrbitalsPage = styled.div`
    font-family: Arial;
    text-align: center;
`;

const PageTitle = styled.div`
    color: #aaaaaa;
    letter-spacing: 2rem;        
    text-align: center;
    font-size: 2.5rem;
    margin: 0.5rem;
    text-shadow: 0.25rem 0.25rem 0.75rem rgba(0,0,0,0.25);
`;

class WindowPane extends Component {
  render() {
    const sizePx = this.props.paneSize + "px";
    const fullBounds = this.props.bounds.top - this.props.bounds.bottom;
    const halfBounds = fullBounds / 2;
    return <WindowPaneWrapper>
      <OrbitalCell
        top={0} left={0} viewport={this.props.viewport}
        bounds={{
          top: this.props.bounds.top,
          right: this.props.bounds.left + halfBounds,
          bottom: this.props.bounds.top - halfBounds,
          left: this.props.bounds.left
        }}
        inverted={this.props.inverted}
        cellId={this.props.parentId + (this.props.inverted ? "-10" : "-00")}
        size={this.props.paneSize}
        level={this.props.level + 1}/>
      <OrbitalCell
        top={0} left={sizePx} viewport={this.props.viewport}
        bounds={{
          top: this.props.bounds.top,
          right: this.props.bounds.left + fullBounds,
          bottom: this.props.bounds.top - halfBounds,
          left: this.props.bounds.left + halfBounds
        }}
        inverted={this.props.inverted}
        cellId={this.props.parentId + (this.props.inverted ? "-11" : "-01")}
        size={this.props.paneSize}
        level={this.props.level + 1}/>
      <OrbitalCell
        top={sizePx} left={0} viewport={this.props.viewport}
        bounds={{
          top: this.props.bounds.top - halfBounds,
          right: this.props.bounds.left + halfBounds,
          bottom: this.props.bounds.top - fullBounds,
          left: this.props.bounds.left
        }}
        inverted={this.props.inverted}
        cellId={this.props.parentId + (this.props.inverted ? "-00" : "-10")}
        size={this.props.paneSize}
        level={this.props.level + 1}/>
      <OrbitalCell
        top={sizePx} left={sizePx} viewport={this.props.viewport}
        bounds={{
          top: this.props.bounds.top - halfBounds,
          right: this.props.bounds.left + fullBounds,
          bottom: this.props.bounds.top - fullBounds,
          left: this.props.bounds.left + halfBounds
        }}
        inverted={this.props.inverted}
        cellId={this.props.parentId + (this.props.inverted ? "-01" : "-11")}
        size={this.props.paneSize}
        level={this.props.level + 1}/>
    </WindowPaneWrapper>;
  }
}

class OrbitalCell extends Component {

  state = {
    empty: false,
    imagePath: "",
    imageName: ""
  }

  componentDidMount() {
    const imagePath = this.props.cellId.replace(/-/g, '/', -1);
    const imageName = "img_" + this.props.cellId + "_256.jpg";
    this.setState({
      imagePath: imagePath,
      imageName: imageName,
    });
  }

  render() {
    const sizePx = this.props.size + "px";
    const level = this.props.level ? this.props.level : 1;
    const windowPane = this.props.size > newPaneSize ? <WindowPane
      viewport={this.props.viewport}
      bounds={this.props.bounds}
      inverted={this.props.inverted}
      paneSize={this.props.size / 2}
      parentId={this.props.cellId}
      level={this.props.level}/> : '';
    const outOfBounds =
      this.props.bounds.right < this.props.viewport.left ||
      this.props.bounds.bottom > this.props.viewport.top ||
      this.props.bounds.left > this.props.viewport.right ||
      this.props.bounds.top < this.props.viewport.bottom;
    const cellContent = outOfBounds ? '' : <div>
      <img
        alt={' '}
        onError={(e) => e.target.style.display = 'none'}
        style={{
          width: sizePx, height: sizePx,
          transform: this.props.inverted ? "scaleY(-1)" : "none"
        }}
        src={bucketRoot + "/" + this.state.imagePath + "/" + this.state.imageName}
      />
      {windowPane}
    </div>
    return this.state.empty ? '' : <CellWrapper
      style={{
        width: sizePx,
        height: sizePx,
        zIndex: level,
        top: this.props.top,
        left: this.props.left,
        // opacity: 0.5
      }}>
      {cellContent}
    </CellWrapper>;
  }
}

export class Orbitals extends Component {

  state = {
    factor: 1,
    hScroll: 0,
    vScroll: 0,
    viewport: {top: 1.0, right: 1.0, bottom: -1.0, left: -2.0},
    scrollerRef: null
  };

  componentDidMount() {
    document.title = 'atlas of orbitals';
    document.body.style.margin = "0 auto";
    document.body.style.backgroundColor = "#f0f0f0";

    this.setState({scrollerRef: React.createRef()})
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const scroller_ref = this.state.scrollerRef;
    scroller_ref.current.scrollTop = this.state.vScroll;
    scroller_ref.current.scrollLeft = this.state.hScroll;
  }

  onScroll(e) {
    const viewport = {
      top: 1.0 - e.target.scrollTop / (this.state.factor * baseSize),
      right: (e.target.scrollLeft + e.target.clientWidth) / (this.state.factor * baseSize) - 2.0,
      bottom: 1.0 - (e.target.scrollTop + e.target.clientHeight) / (this.state.factor * baseSize),
      left: e.target.scrollLeft / (this.state.factor * baseSize) - 2.0
    };
    this.setState({
      viewport: viewport,
      hScroll: e.target.scrollLeft,
      vScroll: e.target.scrollTop
    });
  }

  onZoom(factor) {
    const newFactor = Math.pow(2.0, factor - 1);
    const scalar = newFactor / this.state.factor;
    const newHScroll = scalar * (this.state.hScroll + 200);
    const newVScroll = scalar * (this.state.vScroll + 150);
    this.setState({
      factor: newFactor,
      hScroll: newHScroll,
      vScroll: newVScroll
    });
  }

  render() {
    const size = baseSize * this.state.factor;
    const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
    const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;
    return <OrbitalsPage
      onScroll={(e) => this.onScroll(e)}>
      <PageTitle>atlas of orbitals</PageTitle>
      <Wrapper>
        <Graphics ref={this.state.scrollerRef}>
          <OrbitalCell
            cellId={"00-10"} viewport={this.state.viewport}
            bounds={{top: 1.0, right: -1.0, bottom: 0.0, left: -2.0}}
            top={0} left={0} size={size}/>
          <OrbitalCell
            cellId={"00-11"} viewport={this.state.viewport}
            bounds={{top: 1.0, right: 0.0, bottom: 0.0, left: -1.0}}
            top={0} left={size} size={size}/>
          <OrbitalCell
            cellId={"01-10"} viewport={this.state.viewport}
            bounds={{top: 1.0, right: 1.0, bottom: 0.0, left: 0.0}}
            top={0} left={2 * size} size={size}/>
          <OrbitalCell
            cellId={"00-10"} inverted={true} viewport={this.state.viewport}
            bounds={{top: 0.0, right: -1.0, bottom: -1.0, left: -2.0}}
            top={size - 1} left={0} size={size}/>
          <OrbitalCell
            cellId={"00-11"} inverted={true} viewport={this.state.viewport}
            bounds={{top: 0.0, right: 0.0, bottom: -1.0, left: -1.0}}
            top={size - 1} left={size} size={size}/>
          <OrbitalCell
            cellId={"01-10"} inverted={true} viewport={this.state.viewport}
            bounds={{top: 0.0, right: 1.0, bottom: -1.0, left: 0.0}}
            top={size - 1} left={2 * size} size={size}/>
        </Graphics>
        <StyledSlider
          max={16}
          min={1}
          step={0.5}
          invert
          defaultValue={1}
          renderTrack={Track}
          renderThumb={Thumb}
          orientation={"vertical"}
          onChange={(factor) => this.onZoom(factor)}
        />
        <Sidebar>sidebar</Sidebar>
      </Wrapper>
    </OrbitalsPage>
  }
}

export default Orbitals;
